export const PERSONAL_INFO_PAGE_PREFIX = 'personal-info-page';
export const PERSONAL_CONSENT_PAGE_PREFIX = 'personal-consent-page';
export const BANK_INTERFACE_PAGE_PREFIX = 'bank-interface';
export const RESULTS_PAGE_PREFIX = 'results-page';
export const FINAL_PAGE_PREFIX = 'final-page';
export const EMAIL_PAGE_PREFIX = 'email-page';
export const TECHICAL_ERROR_PAGE = 'technical-error-page';
